var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack212({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.55,3.93H8A9.33,9.33,0,0,1,9.5,4a2.2,2.2,0,0,1,.9.35,2.3,2.3,0,0,1,.66.72,2,2,0,0,1,.26,1A2.07,2.07,0,0,1,10.11,8a2.21,2.21,0,0,1,1.21.78A2.06,2.06,0,0,1,11.74,10a2.58,2.58,0,0,1-.27,1.14,2.25,2.25,0,0,1-.75.89,2.43,2.43,0,0,1-1.16.4c-.29,0-1,0-2.09.06H4.55ZM6.28,5.36v2H7.42q1,0,1.26,0A1.19,1.19,0,0,0,9.38,7a.9.9,0,0,0,.25-.67.93.93,0,0,0-.22-.65,1,1,0,0,0-.65-.3c-.17,0-.67,0-1.48,0Zm0,3.42v2.29H7.89A7.41,7.41,0,0,0,9.08,11a1.09,1.09,0,0,0,.63-.34A1.07,1.07,0,0,0,10,10a1.09,1.09,0,0,0-.19-.66,1,1,0,0,0-.54-.39,6.07,6.07,0,0,0-1.54-.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack212);
export default __webpack_public_path__ + "static/media/Symbolpack_2_12.65f04d44fe495fef0278bab1569f7a57.svg";
export { ForwardRef as ReactComponent };